import request from "../utils/request";

export function login (data) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data
  })
}
export function wlogin (data) {
  return request({
    url: '/api/auth/wlogin',
    method: 'post',
    data
  })
}

export function UnbindWechat () {
  return request({
    url: '/api/auth/unbind-wechat',
    method: 'post'
  })
}

export function getWhchatAuthUrl (data) {
  return request({
    url: '/api/auth/w-auth-url',
    method: 'get',
    params: data
  })
}

export function getInfo() {
  return request({
    url: '/api/auth/info',
    method: 'get'
  })
}
